'use strict';

exports.__esModule = true;
exports.Timeline = exports.styles = exports.TimelineItem = undefined;

var _timeline, _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = require('material-ui');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _Item = require('./Item');

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

exports.TimelineItem = _Item2.default;
var styles = exports.styles = {
  root: {
    // height: 24,
    // margin: 100,
    background: "#ccc"
  },
  maxCursorClass: {
    "&.cursor-arrow:after": {
      "content": "''",
      "position": "absolute",
      "top": "0",
      "right": "96%",
      "width": "0",
      "height": "0",
      "border": "12px solid transparent",
      "borderRight": "12px solid #2895D4"
    }
  },
  minCursorClass: {
    "&.cursor-arrow:before": {
      "content": "''",
      "position": "absolute",
      "top": "0",
      "left": "96%",
      "width": "0",
      "height": "0",
      "border": "12px solid transparent",
      "borderLeft": "12px solid #2895D4"
    }
  },
  timeline: (_timeline = {
    "height": 20,
    "display": "inline-flex",
    // "position": "absolute",
    "position": "relative",
    "userSelect": "none",
    "zIndex": "1"
  }, _timeline['display'] = "flex", _timeline.flexWrap = "nowrap", _timeline),
  timeBlock: {
    height: "100%",
    flex: 1,
    whiteSpace: "nowrap",
    // padding: "5px",
    // "width": "200px",
    // "float": "left",
    "padding": "6px 0 0 0",
    // border: "1px solid",
    border: "none",
    // borderColor: "red",
    "userSelect": "none",
    // "MozUserSelect": "none",
    // "WebkitUserSelect": "none",
    // "MsUserSelect": "none",
    "textAlign": "center",
    "fontSize": "smaller",
    zIndex: -1,
    // border: "1px solid",
    "& .time-block--in-range": {// opacity: 0.1,
    }
  },
  position: {
    // border: "1px solid blue",
    background: "#4ff754",
    position: "absolute",
    top: 0,
    bottom: 0,
    zIndex: -1
  },
  control: {
    border: "1px solid #1fa906",
    position: "absolute",
    height: "100%",
    "&.editable": {
      cursor: "pointer"
    }
  },
  itemLabel: {
    "textOverflow": "ellipsis",
    "width": "100%",
    "overflow": "hidden",
    "display": "inline-block",
    "whiteSpace": "nowrap",
    "padding": "3px",
    "textAlign": "center",
    fontSize: "0.8rem"
  }
};
var Timeline = exports.Timeline = (_temp = _class = function (_Component) {
  _inherits(Timeline, _Component);

  function Timeline(props) {
    _classCallCheck(this, Timeline);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      // minCursorX: 0,
      // maxCursorX: 0,
      // minCursorDate: 0,
      // maxCursorDate: 0,
      dragStartDate: null,
      dragEndDate: null
    };
    return _this;
  }

  Timeline.prototype.getTimeline = function getTimeline() {
    return this.timeline;
  };

  Timeline.prototype.getCursorPositionLeft = function getCursorPositionLeft(x) {
    var timeline = this.getTimeline();

    var _timeline$getBounding = timeline.getBoundingClientRect(),
        clientOffsetX = _timeline$getBounding.x;

    this.setState({
      dragStartDate: null
    });
    return x - clientOffsetX;
  };

  Timeline.prototype._getAvailableYearsHtml = function _getAvailableYearsHtml() {
    var _this2 = this;

    var _props = this.props,
        classes = _props.classes,
        minDate = _props.minDate,
        maxDate = _props.maxDate,
        dates = _props.dates,
        editable = _props.editable,
        _onStartDateChange = _props.onStartDateChange,
        _onEndDateChange = _props.onEndDateChange; // const {
    //   dragStartDate = null,
    //   dragEndDate = null,
    // } = this.state;
    // console.log("!minDate || !maxDate || !(maxDate > minDate)", minDate, maxDate, (maxDate > minDate), !minDate || !maxDate || !(maxDate > minDate));

    if (!minDate || !maxDate || !(maxDate > minDate)) {
      return null;
    }

    minDate = (0, _moment2.default)(minDate);
    maxDate = (0, _moment2.default)(maxDate);
    var output = dates.map(function (n, index) {
      // let {
      //   startDate,
      //   endDate,
      // } = n;
      // startDate = moment(startDate);
      // endDate = moment(endDate);
      // console.log("_getAvailableYearsHtml min max", minDate, maxDate, maxDate > minDate, startDate, endDate);
      // let startDateOffset = `${this.getTimelinePosition(startDate)}%`;
      // let endDateOffset = `${100 - this.getTimelinePosition(endDate)}%`;
      // /**
      //  * Учитываем позицию при перетаскивании
      //  */
      // if (dragStartDate !== null) {
      //   startDateOffset = `${dragStartDate}px`;
      // }
      // if (dragEndDate !== null) {
      //   endDateOffset = `calc(100% - ${dragEndDate}px)`;
      // }
      return _react2.default.createElement(_Item2.default, {
        key: index,
        item: n,
        classes: classes,
        minDate: minDate,
        maxDate: maxDate,
        getTimeline: _this2.getTimeline.bind(_this2),
        getCursorPositionLeft: _this2.getCursorPositionLeft.bind(_this2),
        editable: editable,
        onStartDateChange: function onStartDateChange(time) {
          return _onStartDateChange(n, time);
        },
        onEndDateChange: function onEndDateChange(time) {
          return _onEndDateChange(n, time);
        } // style={{
        //   left: startDateOffset,
        //   right: endDateOffset,
        // }}

      }); // return <div
      //   key={index}
      //   className={classes.position}
      //   style={{
      //     left: startDateOffset,
      //     right: endDateOffset,
      //   }}
      // >
      //   <div
      //     className={classes.control}
      //     style={{
      //       left: 0,
      //     }}
      //     onMouseDown={event => this.onTimelineMouseDown(event, "dragStartDate")}
      //   />
      //   <div
      //     className={classes.control}
      //     style={{
      //       right: 0,
      //     }}
      //     onMouseDown={event => this.onTimelineMouseDown(event, "dragEndDate")}
      //   />
      // </div>
    });
    return output;
  };

  Timeline.prototype.render = function render() {
    var _this3 = this;

    var _props2 = this.props,
        classes = _props2.classes,
        minDate = _props2.minDate,
        maxDate = _props2.maxDate,
        other = _objectWithoutProperties(_props2, ['classes', 'minDate', 'maxDate']);

    var timelineWrapperClass = 'timeline-wrapper';
    if (this.props.disabled) timelineWrapperClass += ' timeline--disabled';
    return _react2.default.createElement('div', {
      className: [classes.root, timelineWrapperClass].join(" "),
      ref: function ref(_ref) {
        return _this3.timelineWrapper = _ref;
      }
    }, _react2.default.createElement('div', {
      className: [classes.timeline, "timeline-available"].join(" "),
      ref: function ref(el) {
        _this3.timeline = el;
      }
    }, this._getAvailableYearsHtml()));
  };

  return Timeline;
}(_react.Component), _class.defaultProps = {
  editable: false
}, _temp);
Timeline.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes2.default.object.isRequired,
  editable: _propTypes2.default.bool.isRequired,
  minDate: _propTypes2.default.number.isRequired,
  maxDate: _propTypes2.default.number.isRequired,
  dates: _propTypes2.default.array.isRequired,
  // startDate: PropTypes.number.isRequired,
  // endDate: PropTypes.number.isRequired,
  onStartDateChange: _propTypes2.default.func.isRequired,
  onEndDateChange: _propTypes2.default.func.isRequired
} : {};
exports.default = (0, _materialUi.withStyles)(styles)(Timeline);